export default __webpack_public_path__ + "static/media/Group9159.577fade7.svg";